export default __webpack_public_path__ + "static/media/reload.7f2f066d.png";